module.exports = __webpack_public_path__ + "images/d6a8ee41024d56571ad3e837ed16a64d-form-header.png";